export { saveToStorage } from './saveToStorage';
export { getFromStorage } from './getFromStorage';
export { resolveStorageArea } from './resolveStorageArea';
